module.exports = __webpack_public_path__ + "img/altaiyz-design.8956d835.jpg";